import { AfterViewInit, Component, EventEmitter, Injector, Input, NgZone, OnDestroy, Output } from '@angular/core';
import { GeozoneStyleViewModel } from "../../../admin-panel/Geozone/Model/GeozoneViewModel"
import { JSProxyService } from "../../../../services/jsproxy.service";

export class MapPoint {
  lat: number;
  lng: number;
  constructor(lat: number, lng: number) {
    this.lat = lat;
    this.lng = lng;
  }
}

export class MapObject {
  type: string = "Point";
  points: Array<MapPoint> = [];

  geozoneId: number = 0;        //для простоты рисования геозоны

  label: string = "";

  icon: string = null;

  style: GeozoneStyleViewModel = new GeozoneStyleViewModel();

  modify: boolean = false;
}

@Component({
    selector: 'simple-map',
    templateUrl: './c.component.html',
    styleUrls: ['./c.component.css'],
    standalone: false
})
export class SimpleMapComponent implements OnDestroy,AfterViewInit {

  @Input()
  public mapMode: string = "";
  @Input()
  public mapId: string = "map";
  @Output()
  public onDrawFinish: EventEmitter<Array<MapPoint>> = new EventEmitter<Array<MapPoint>>();

  jsMapControl: any = null;
  mapObjects: Array<MapObject> = null;

  jsProxy: JSProxyService;
  ngZone: NgZone;

  constructor(protected injector: Injector) {
    this.jsProxy = injector.get(JSProxyService);
    this.ngZone = injector.get(NgZone);
  }

  ngAfterViewInit() {
    this.jsProxy.registerComponent(this.mapId, this, "");
    window.dispatchEvent(new CustomEvent("Evt2Control", { detail: { control: "dialogmapcontrol"}}));
  }
  ngOnDestroy() {
    this.jsProxy.unRegisterComponent(this.mapId);
  }
  public isMode(mode: string): boolean {
    return this.mapMode.indexOf(mode) >= 0;
  }

  public onLoad(map: any) {
    this.jsMapControl = map;

    this.ShowObjects(this.mapObjects, true);
  }

  public ShowObjects(objects: Array<MapObject>, needCenter: boolean) {
    this.mapObjects = objects;

    if (!this.jsMapControl)
      return;

    this.jsMapControl.ClearTools();

    if (this.mapObjects && this.mapObjects.length)
      this.jsMapControl.AddFeatures(this.mapObjects, needCenter);
  }

  public HideObjectsLayer() {
    if (!this.jsMapControl)
      return;

    this.jsMapControl.SetStyle({ "showObjectsAndGeozones": false });
  }

  public ShowObjectsLayer() {
    if (!this.jsMapControl)
      return;

    this.jsMapControl.SetStyle({ "showObjectsAndGeozones": true });
  }

  public onDrawEnd(points: Array<MapPoint>) {//этот метод вызовется при окончании рисования объекта
    this.ngZone.run(() => {
      this.onDrawFinish.emit(points);
    });
  }
}
